var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "widget-inner d-flex flex-wrap" },
      [
        _vm._l(_vm.currentVariation.variationProperties, function (propGroup) {
          return [
            _vm._l(propGroup.properties, function (prop) {
              return [
                _vm.splitProps.includes(prop.id.toString())
                  ? [
                      prop.values
                        ? [
                            _c(
                              "div",
                              { staticClass: "propContainer" },
                              [
                                prop.cast == "text"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "textProperty propWrapper textProp",
                                        },
                                        [
                                          prop.names.description.length > 0
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "iconWrapper",
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "propIcon img-fluid",
                                                      attrs: {
                                                        src: prop.names
                                                          .description,
                                                        alt: prop.names.name,
                                                        title: prop.names.name,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "textWrapper" },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        prop.values.value
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                  prop.id == 71 || prop.id == 86
                                                    ? [
                                                        _vm._v(
                                                          "\n                                                mm\n                                            "
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  : prop.cast == "int"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "numberProperty propWrapper intProp",
                                        },
                                        [
                                          prop.names.description.length > 0
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "iconWrapper",
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "propIcon img-fluid",
                                                      attrs: {
                                                        src: prop.names
                                                          .description,
                                                        alt: prop.names.name,
                                                        title: prop.names.name,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "textWrapper" },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        prop.values.value
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                  prop.options.units[0] == "GRM"
                                                    ? [
                                                        _vm._v(
                                                          "\n                                                g\n                                            "
                                                        ),
                                                      ]
                                                    : [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              prop.options
                                                                .units[0]
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ],
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  : prop.cast == "selection"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "iconProperty propWrapper selectionProp",
                                        },
                                        [
                                          prop.values.description.length > 0
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "iconWrapper",
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "propIcon img-fluid",
                                                      attrs: {
                                                        src: prop.values
                                                          .description,
                                                        alt: prop.values.value,
                                                        title:
                                                          prop.values.value,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "textWrapper" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(prop.values.value) +
                                                    "\n                                        "
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "iconProperty propWrapper",
                                          class: {
                                            openInfoModal:
                                              prop.id == 87 &&
                                              _vm.$translate(
                                                "CeresCoconut::Template.itemVarPropModalText87"
                                              ).length > 0,
                                          },
                                          attrs: {
                                            "data-modaltitle":
                                              "modalTitleVP" + prop.id,
                                            "data-modaltext":
                                              "modalTextVP" + prop.id,
                                          },
                                        },
                                        [
                                          prop.names.description.length > 0
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "iconWrapper",
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "propIcon img-fluid",
                                                      attrs: {
                                                        src: prop.names
                                                          .description,
                                                        alt: prop.names.name,
                                                        title: prop.names.name,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    prop.id == 87 &&
                                                    _vm.$translate(
                                                      "CeresCoconut::Template.itemVarPropModalText87"
                                                    ).length > 0
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "propInfo",
                                                          },
                                                          [
                                                            _c("lazy-img", {
                                                              ref: "itemLazyImage",
                                                              refInFor: true,
                                                              attrs: {
                                                                "picture-class":
                                                                  "",
                                                                "image-url":
                                                                  " https://cdn02.plentymarkets.com/4tnz2nlw17zy/frontend/Icons/Kosmetikspiegel_Attributeinfo.svg",
                                                                alt: prop.values
                                                                  .values,
                                                                title:
                                                                  prop.values
                                                                    .values,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "textWrapper" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(prop.names.name) +
                                                    "\n                                        "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          prop.id == 87
                                            ? [
                                                _vm.$translate(
                                                  "CeresCoconut::Template.itemVarPropModalText87"
                                                ).length > 0
                                                  ? [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "attribueInfoContent",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class:
                                                                "modalTitleVP" +
                                                                prop.id,
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    _vm.$translate(
                                                                      "CeresCoconut::Template.itemVarPropModalHeading87"
                                                                    )
                                                                  ) +
                                                                  "\n                                                "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              class:
                                                                "modalTextVP" +
                                                                prop.id,
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    _vm.$translate(
                                                                      "CeresCoconut::Template.itemVarPropModalText87"
                                                                    )
                                                                  ) +
                                                                  "\n                                                "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ]
            }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }